import GamesResultsLayout from "../../../layouts/games/GamesResultsLayout";
import GamesLooseResultContent from "../GamesLooseResultContent";
import GamesRecordResultContent from "../GamesRecordResultContent";
import {kMultiplicationLists} from "../../../../constants/lists";
import {kGamesNumbers} from "../../../../constants/numbers";
import GamesSuccessResultContent from "../GamesSuccessResultContent";
import GamesResultsBottomBar from "../../../bars/games/GamesResultsBottomBar";

export default function MultiplicationResults({ isLost,
                                                finalScore,
                                                lastMultiplication,
                                                lastAnswer,
                                                onRetryPressed }) {
    // Used in MultiplicationGameScreen to display loose, success of
    // record related content

    // BUILD
    return (
        <div className={"animate-appearSlow bg-backgroundLight3 w-full h-full flex flex-col justify-center items-center"}>
            <GamesResultsLayout>
                {isLost
                    ? <GamesLooseResultContent
                        lastQuestion={lastMultiplication}
                        finalScore={finalScore}
                        lastAnswer={lastAnswer}
                        advicesList={kMultiplicationLists.looseAdvices} />
                    : finalScore > kGamesNumbers.multiplicationRecord
                        ? <GamesRecordResultContent finalScore={finalScore}
                                                    advicesList={kMultiplicationLists.recordAdvices} />
                        : <GamesSuccessResultContent finalScore={finalScore} /> }
                <GamesResultsBottomBar
                    onRetryPressed={onRetryPressed} />
            </GamesResultsLayout>
        </div>
    );
}